import clsx from 'clsx'
import { useEffect, useMemo, useState } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'

import cityJobsIcon from '@/assets/img/ico-city-job.svg'
import closedJobsIcon from '@/assets/img/ico-closed-job.svg'
import jobsIcon from '@/assets/img/ico-jobs.svg'
import openJobsIcon from '@/assets/img/ico-open-jobs.svg'
import RatingDownIcon from '@/assets/img/ico-rate-down.svg?react'
import RatingUpIcon from '@/assets/img/ico-rate-up.svg?react'
import DoughnutChart from '@/compoments/charts/DoughnutChart'
import HorizontalBarChart from '@/compoments/charts/HorizontalBarChart'
import StackedBarChart from '@/compoments/charts/StackedBarChart'
import TrendChart from '@/compoments/charts/TrendChart'
import SelectBox from '@/compoments/common/SelectBox'
import PageLoader from '@/compoments/PageLoader'
import { useGetGroupStatisticsQuery } from '@/services/tenant/workGroups'
import {
    getStartAndEndOfMonth,
    getStartAndEndOfWeek,
    getStartAndEndOfYear,
} from '@/utils/helpers'
import { optionsCharts } from '@/utils/selectsOptionsConst'

interface JobStatistics {
    label: string
    icon: string
    trend: 'up' | 'down'
    value: number
    percent: number
}

const Statistics = () => {
    const [searchParams, setSearchParams] = useSearchParams()
    const params = useMemo(
        () => ({
            feedbackStartDate: searchParams.get('feedbackStartDate'),
            feedbackEndDate: searchParams.get('feedbackEndDate'),
            zoneStartDate: searchParams.get('zoneStartDate'),
            zoneEndDate: searchParams.get('zoneEndDate'),
        }),
        [searchParams],
    )
    console.log(params, 'params')
    const [statistikTypes, setStatistikTypes] = useState({
        feedback: 'week',
        zones: 'week',
    })
    const { id } = useParams()
    const { data, isLoading } = useGetGroupStatisticsQuery(
        { id: Number(id), qwery: `no_limit=true&${searchParams.toString()}` },
        { skip: !id },
    )
    useEffect(() => {
        if (params.feedbackStartDate && params.feedbackEndDate) return
        setParams(new Date(), 'feedback')
    }, [])
    useEffect(() => {
        if (params.zoneStartDate && params.zoneEndDate) return
        setParams(new Date(), 'zones')
    }, [])

    const pageData = data?.data

    const handelSelectChange = (
        value: string,
        type: keyof typeof statistikTypes,
    ) => {
        setParams(new Date(), type, value)
        setStatistikTypes((prev) => ({
            ...prev,
            [type]: value,
        }))
    }

    const setParams = (
        date: Date,
        type: keyof typeof statistikTypes,
        value: string = 'week',
    ) => {
        const { startDate: startDateWeek, endDate: endDateWeek } =
            getStartAndEndOfWeek(date)
        const { startDate: startDateMonth, endDate: endDateMonth } =
            getStartAndEndOfMonth(date)
        const { startDate: startDateYear, endDate: endDateYear } =
            getStartAndEndOfYear(date)
        setSearchParams((prev) => {
            prev.set(
                type === 'feedback' ? 'feedbackStartDate' : 'zoneStartDate',
                value === 'week'
                    ? startDateWeek
                    : value === 'month'
                      ? startDateMonth
                      : startDateYear,
            )
            prev.set(
                type === 'feedback' ? 'feedbackEndDate' : 'zoneEndDate',
                value === 'week'
                    ? endDateWeek
                    : value === 'month'
                      ? endDateMonth
                      : endDateYear,
            )
            return prev
        })
    }

    const jobStatistics: JobStatistics[] = [
        {
            label: 'Jobs',
            icon: jobsIcon,
            trend:
                Number(pageData?.orderStatistics?.total?.changed) >= 0
                    ? 'up'
                    : 'down',
            value: pageData?.orderStatistics?.total?.value || 0,
            percent: Number(pageData?.orderStatistics?.total?.changed) || 0,
        },
        {
            label: 'Open Jobs',
            icon: openJobsIcon,
            trend:
                Number(pageData?.orderStatistics?.open?.changed) >= 0
                    ? 'up'
                    : 'down',
            value: pageData?.orderStatistics?.open?.value || 0,
            percent: Number(pageData?.orderStatistics?.open?.changed) || 0,
        },
        {
            label: 'KIV Jobs',
            icon: cityJobsIcon,
            trend:
                Number(pageData?.orderStatistics?.kiv?.changed) >= 0
                    ? 'up'
                    : 'down',
            value: pageData?.orderStatistics?.kiv?.value || 0,
            percent: Number(pageData?.orderStatistics?.kiv?.changed) || 0,
        },
        {
            label: 'Closed Jobs',
            icon: closedJobsIcon,
            trend:
                Number(pageData?.orderStatistics?.closed?.changed) >= 0
                    ? 'up'
                    : 'down',
            value: pageData?.orderStatistics?.closed?.value || 0,
            percent: Number(pageData?.orderStatistics?.closed?.changed) || 0,
        },
    ]
    console.log(jobStatistics, pageData)

    if (isLoading) return <PageLoader />

    return (
        <div
            className="tab flex-auto active-tab overflow-hidden "
            data-id="task-list"
        >
            <div className="table-body table-responsive p-20">
                <div className="row gutters-28">
                    <div className="col-12">
                        <div className="row gutters-18">
                            {jobStatistics.map((item, index) => (
                                <div
                                    key={index}
                                    className="col-xl-3 col-md-6 col-12"
                                >
                                    <div className="card card-shadow card-seo">
                                        <div className="card-body">
                                            <div className="card-seo-info flex-shrink-0">
                                                <div className="seo-title">
                                                    <span className="ico">
                                                        <img
                                                            src={item.icon}
                                                            alt={item.label}
                                                        />
                                                    </span>
                                                    <span className="name">
                                                        {item.label}
                                                    </span>
                                                </div>
                                                <h1 className="seo-stat-title">
                                                    {item.value}
                                                </h1>
                                            </div>
                                            <div
                                                className="card-seo-chart"
                                                style={{
                                                    height: 60,
                                                    width: 100,
                                                }}
                                            >
                                                <TrendChart
                                                    trend={item.trend}
                                                />
                                            </div>
                                        </div>
                                        <div className="card-footer">
                                            <div className="seo-rating-row">
                                                <div
                                                    className={clsx(
                                                        'seo-rating',
                                                        `--${item.trend}`,
                                                    )}
                                                >
                                                    <span className="ico">
                                                        {item.trend === 'up' ? (
                                                            <RatingUpIcon />
                                                        ) : (
                                                            <RatingDownIcon />
                                                        )}
                                                    </span>{' '}
                                                    <span>
                                                        {item.trend === 'up'
                                                            ? '+'
                                                            : '-'}
                                                        {item.percent}%
                                                    </span>
                                                </div>
                                                <p className="seo-rating-desk">
                                                    <span>vs</span> yesterday
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="row gutters-18">
                            <div className="col-xl-4 col-md-6">
                                <div className="card card-shadow card-chart h-full">
                                    <div className="card-header">
                                        <div className="card-chart-title text--xl">
                                            Feedback
                                        </div>
                                        <SelectBox
                                            wrapperClassName="select--transparent"
                                            options={optionsCharts}
                                            defaultValue={optionsCharts[0]}
                                            onChange={(option) => {
                                                if (!option?.value) return
                                                handelSelectChange(
                                                    String(option?.value),
                                                    'feedback',
                                                )
                                            }}
                                        />
                                    </div>
                                    <div className="card-body">
                                        <DoughnutChart
                                            labels={Object.entries(
                                                pageData?.feedbackStatistics ||
                                                    {},
                                            )
                                                .filter(
                                                    ([key]) => key !== 'total',
                                                )
                                                .map(([key, value]) => key)}
                                            values={Object.entries(
                                                pageData?.feedbackStatistics ||
                                                    {},
                                            )
                                                .filter(
                                                    ([key]) => key !== 'total',
                                                )
                                                .map(([key, value]) => value)}
                                            total={
                                                pageData?.feedbackStatistics
                                                    .total
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-md-6">
                                <div className="card card-shadow card-chart h-full">
                                    <div className="card-header">
                                        <div className="card-chart-title text--xl">
                                            Jobs by Zone
                                        </div>
                                        <SelectBox
                                            wrapperClassName="select--transparent"
                                            options={optionsCharts}
                                            defaultValue={optionsCharts[0]}
                                            onChange={(option) => {
                                                if (!option?.value) return
                                                handelSelectChange(
                                                    String(option?.value),
                                                    'zones',
                                                )
                                            }}
                                        />
                                    </div>
                                    <div className="card-body">
                                        <HorizontalBarChart
                                            labels={Object.keys(
                                                pageData?.zoneStatistics || {},
                                            )
                                                .filter(
                                                    (key) => key !== 'total',
                                                )
                                                .map((key) => key)}
                                            values={Object.entries(
                                                pageData?.zoneStatistics || {},
                                            )
                                                .filter(
                                                    ([key]) => key !== 'total',
                                                )
                                                .map(([key, value]) => value)}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-md-6">
                                <div className="card card-shadow card-chart h-full">
                                    <div className="card-header">
                                        <div className="card-chart-title text--xl">
                                            Total Transactions
                                        </div>
                                        {/* <SelectBox
                                            wrapperClassName="select--transparent"
                                            options={options}
                                        /> */}
                                    </div>
                                    <div className="card-body">
                                        <StackedBarChart
                                            labels={Object.keys(
                                                pageData?.transactions || {},
                                            ).map((key) => key)}
                                            values={[
                                                Object.values(
                                                    pageData?.transactions ||
                                                        {},
                                                ).map((day) => day.thisWeek),
                                                Object.values(
                                                    pageData?.transactions ||
                                                        {},
                                                ).map((day) => day.lastWeek),
                                                Object.values(
                                                    pageData?.transactions ||
                                                        {},
                                                ).map((day) => day.cost),
                                            ]}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Statistics
